import React from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";

function TargetArchitectureBasedConversion() {


  return (
    <>
      <CloneRepo />
    </>
  );
}

export default TargetArchitectureBasedConversion;